module.exports = __webpack_public_path__ + "img/1-5-p4.043cded2.svg";